module.exports = __webpack_public_path__ + "img/content_btn_pause.ab334507.svg";